import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "not-found-view" }
const _hoisted_2 = { class: "content-wrapper" }
const _hoisted_3 = { class: "error-container ln-glass-elevated" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NavBar = _resolveComponent("NavBar")!
  const _component_NavIsland = _resolveComponent("NavIsland")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_NavBar),
    _createVNode(_component_NavIsland),
    _createElementVNode("main", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[2] || (_cache[2] = _createElementVNode("h1", null, "404", -1)),
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('common.pageNotFound')), 1),
        _createElementVNode("p", null, _toDisplayString(_ctx.$t('common.pageNotFoundDesc')), 1),
        _createElementVNode("button", {
          class: "cta-primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push({ name: 'home' })))
        }, [
          _cache[1] || (_cache[1] = _createElementVNode("span", { class: "mdi mdi-home" }, null, -1)),
          _createTextVNode(" " + _toDisplayString(_ctx.$t('common.backToHome')), 1)
        ])
      ])
    ])
  ]))
}